module.exports = __webpack_public_path__ + "img/sec5_12.b453df77.jpg";